// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__R9blQ","paramInput":"JobSimulator_paramInput__TT0lT","input":"JobSimulator_input__1CG3u"};